interface Props {
  icon?: string
  title: string
  detail?: string
  status: "inProgress" | "complete" | "executing" | string
}

export function ToolProgressCard({ icon = "⚙", title, detail, status }: Props) {
  const isRunning = status === "inProgress" || status === "executing"

  return (
    <div className="flex items-start gap-2 rounded-md border border-gray-200 bg-gray-50 px-3 py-2 text-xs">
      <span className={isRunning ? "animate-spin" : ""}>{icon}</span>
      <div className="min-w-0">
        <span className="font-medium text-gray-700">{title}</span>
        {detail ? <p className="mt-0.5 truncate text-gray-500">{detail}</p> : null}
      </div>
      {status === "complete" ? <span className="ml-auto text-green-600">✓</span> : null}
    </div>
  )
}
